import { render, staticRenderFns } from "./QuotaForm.vue?vue&type=template&id=3724b7fe&"
import script from "./QuotaForm.vue?vue&type=script&lang=js&"
export * from "./QuotaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports